import dayjs from "dayjs"

import type { CalendarModalData } from "../../redux/calendar.types.ts"

const SLOT_MINUTES = 15
const DEFAULT_DURATION_MINUTES = 30

export const resolveNewEventSlot = (
  dateStr: string,
  timezone?: string
): CalendarModalData => {
  const selectedDay = dayjs.tz(dateStr, timezone)

  const roundedDate = selectedDay
    .minute(Math.round(selectedDay.minute() / SLOT_MINUTES) * SLOT_MINUTES)
    .second(0)
    .millisecond(0)

  return {
    date: roundedDate,
    start_at: roundedDate,
    end_at: roundedDate.add(DEFAULT_DURATION_MINUTES, "minute")
  }
}
